import { render } from "./App.vue?vue&type=template&id=5d40ab3f"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5d40ab3f&lang=css"

import exportComponent from "F:\\Projetos-Lefisc\\front-end\\front_retfont\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__